import React, { Component } from "react";
import {
  message,
  PageHeader,
  Spin,
  Row,
  Col,
  Divider,
  Select,
  Form as FormInitial,
  Tooltip,
} from "antd";
import {
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  DatePickerItem,
  NotificacionPolizas,
  NotificacionMovimientosInventario,
  ButtonItem,
  ErrorItem,
  calcularMaxDisponible
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import ElegirMarbetes from "../../Marbetes/ElegirMarbetes/ElegirMarbetes";
import ElegirLotes from "../../LotesCaducidades/ElegirLotes/ElegirLotes";
import ElegirAgrupaciones from "../../Agrupaciones/ElegirAgrupaciones/ElegirAgrupaciones";
import { CalculatorOutlined } from "@ant-design/icons";

const { Option } = Select;

moment.locale("es");

class EntregarInsumosEmbarque extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    datosEmbarque: undefined,
    todasInsumos: null,
    objetoInsumos: null,
    todasProyectos: null,
    objetoProyectos: null,
    id: this.props.location.state.id,
  };
  componentDidMount() {
    this.consultarTodo();
  }

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "embarques/datosEmbarquePRecibirP",
        {
          empresaId: this.props.empresaId,
          embarqueId: this.state.id,
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then(async (res) => {
        if (res.data.success === 2) {
          this.setState({
            datosEmbarque: res.data.embarque,
            todasInsumos: res.data.insumos,
            objetoInsumos: res.data.insumos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.stringBuscar}
                </Option>
              );
            }),
          });
          const insumosFormato = res.data.embarque.insumos.map(value => {
            return { ...value, precioUnitarioAjustado: (value.precioUnitario * (1 - (value.descuento / 100))) }
          });
          this.formRef.current.setFieldsValue({ insumos: insumosFormato });

          const insumosBulk = insumosFormato.map((row, index) => {
            const insumoOriginal = res.data.insumos.find(i => i._id.toString() === row.insumoId.toString());
            return {
              index,
              insumoId: row.insumoId,
              proyectoId: row.proyectoId,
              inventariable: insumoOriginal?.inventariable,
              noPrincipal: insumoOriginal?.noPrincipal,
              insumoCompuesto: insumoOriginal?.insumoCompuesto,
            };
          });
          try {
            const resInventarios = await axios.post(
              "inventarios/inventarioInsumoProyectoBulk",
              { empresaId: this.props.empresaId, insumos: insumosBulk, embarqueId: this.state.id },
              { headers: this.props.headersToken }
            );
            if (resInventarios.data?.results) {
              resInventarios.data.results.forEach(r => {
                insumosFormato[r.index].cantidadProyecto = r.cantidad !== null ? r.cantidad : "No inventariable";
              });
              this.formRef.current.setFieldsValue({ insumos: insumosFormato });
            }
          } catch (e) {
            console.error("Error al consultar inventario bulk", e);
          }
        } else {
          message.error(
            "Error no se encontro informacion del embarque"
          );
        }
      });
    this.setState({ loading: false });
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    let entregarTodos = 0;
    values.insumos = values.insumos.map(value => {
      let entregar = value.entregar ? value.entregar : 0
      entregarTodos += entregar
      return { ...value, entregar }
    })
    if (entregarTodos === 0) return message.info('Se neceitan cantidades para poder hacer esta operación')
    this.setState({ loading: true });
    axios
      .post(
        "embarques/entregarInsumos",
        {
          ...values,
          empresaId: this.props.empresaId,
          embarqueId: this.state.id,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            "Se han entregado insumos del embarque: " + res.data.codigo
          );
          NotificacionPolizas(res.data.polizasId)
          NotificacionMovimientosInventario(res.data.movimientosIds)
          this.formRef.current.resetFields();
          this.atras();
        } else if (res.data.success === 1) {
          message.error(res.data.message ? res.data.message : "No se pueden entregar los insumos");
        } else {
          message.error("Hubo un error y no se entregaron los insumos");
        }
      });
  }
  atras() {
    this.props.history.goBack();
  }
  async onChangeInsumoProyecto(value, key) {
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let proyectoId = arrayValue[key].proyectoId;
    const insumoId = arrayValue[key].insumoId;
    const insumo = this.state.todasInsumos.find(
      (valueInsumos) => valueInsumos._id === insumoId
    );
    if (!insumo) return
    if (insumo.inventariable || insumo.insumoCompuesto) {
      await axios
        .post(
          "inventarios/inventarioInsumoProyecto",
          {
            proyectoId: proyectoId,
            insumoId: insumoId,
            embarqueId: this.state.id,
            noPrincipal: insumo.noPrincipal,
            insumoCompuesto: insumo.insumoCompuesto,
            empresaId: this.props.empresaId,
          },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          this.setState({ loading: false });
          arrayValue[key].cantidadProyecto = res.data.cantidad;
        });
    } else {
      arrayValue[key].cantidadProyecto = "No inventariable";
    }
    this.formRef.current.setFieldsValue({
      insumos: arrayValue,
    });
  }
  abrirElegirMarbetes(value, marbetes, insumoId, proyectoId) {
    if (proyectoId) {
      this.setState({
        modalElegirMarbetes: true,
        modalElegirMarbetesIndex: value,
        modalElegirMarbetesMarbetes: marbetes || [],
        modalElegirMarbetesInsumoId: insumoId,
        modalElegirMarbetesProyectoId: proyectoId
      })
    } else {
      message.warning('Elegir un proyecto para elegir marbetes')
    }
  }
  cerrarElegirMarbetes(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalElegirMarbetesIndex].marbetes = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirMarbetes: false,
      modalElegirMarbetesIndex: null,
      modalElegirMarbetesMarbetes: null,
      modalElegirMarbetesInsumoId: null,
      modalElegirMarbetesProyectoId: null
    })
  }
  abrirElegirLotes(value, lotes, insumoId, proyectoId, cantidad) {
    const clienteId = this.formRef.current.getFieldValue('clienteId')
    if (proyectoId) {
      this.setState({
        modalElegirLotes: true,
        modalElegirLotesIndex: value,
        modalElegirLotesLotes: lotes || [],
        modalElegirLotesInsumoId: insumoId,
        modalElegirLotesProyectoId: proyectoId,
        modalElegirLotesClienteId: clienteId,
        modalElegirLotesCantidad: cantidad
      })
    } else {
      message.warning('Elegir un proyecto para elegir lotes')
    }
  }
  cerrarElegirLotes(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalElegirLotesIndex].lotes = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirLotes: false,
      modalElegirLotesIndex: null,
      modalElegirLotesLotes: null,
      modalElegirLotesInsumoId: null,
      modalElegirLotesProyectoId: null,
      modalElegirLotesClienteId: null,
      modalElegirLotesCantidad: null
    })
  }
  abrirElegirAgrupaciones(value, agrupaciones, insumoId, proyectoId) {
    const clienteId = this.formRef.current.getFieldValue('clienteId')
    if (proyectoId) {
      this.setState({
        modalElegirAgrupaciones: true,
        modalElegirAgrupacionesIndex: value,
        modalElegirAgrupacionesAgrupaciones: agrupaciones || [],
        modalElegirAgrupacionesInsumoId: insumoId,
        modalElegirAgrupacionesProyectoId: proyectoId,
        modalElegirAgrupacionesClienteId: clienteId
      })
    } else {
      message.warning('Elegir un proyecto para elegir agrupaciones')
    }
  }
  cerrarElegirAgrupaciones(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalElegirAgrupacionesIndex].agrupaciones = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirAgrupaciones: false,
      modalElegirAgrupacionesIndex: null,
      modalElegirAgrupacionesAgrupaciones: null,
      modalElegirAgrupacionesInsumoId: null,
      modalElegirAgrupacionesProyectoId: null,
      modalElegirAgrupacionesClienteId: null
    })
  }

  setMaxEntregarTodos = async () => {
    const form = this.formRef?.current;
    if (!form) return;
    this.setState({ loading: true });

    const insumos = form.getFieldValue("insumos") || [];

    const maxPorFila = insumos.map((row, idx) => calcularMaxDisponible({
      cantidad: this.state?.datosEmbarque?.insumos?.[idx]?.cantidad,
      yaMovido: this.state?.datosEmbarque?.insumos?.[idx]?.entregado,
      cantidadProyecto: row?.cantidadProyecto,
    }));

    const insumosConLotes = insumos
      .map((row, idx) => {
        const insumo = this.state.todasInsumos?.find(i => i._id === row?.insumoId);
        if (!insumo?.lotesCaducidades || maxPorFila[idx] <= 0) return null;
        return { insumoId: row.insumoId, proyectoId: row.proyectoId, cantidad: maxPorFila[idx], _idx: idx };
      })
      .filter(Boolean);

    let resultadosMap = {};
    if (insumosConLotes.length > 0) {
      try {
        const res = await axios.post(
          "lotes/selectLotesDiponiblesMasivoRecomendadoConApartados",
          {
            empresaId: this.props.empresaId,
            insumos: insumosConLotes.map(({ insumoId, proyectoId, cantidad, _idx }) => ({ insumoId, proyectoId, cantidad, idx: _idx })),
            embarqueId: this.state.id,
          },
          { headers: this.props.headersToken }
        );
        if (res.data.success === 2) {
          res.data.resultados.forEach((r) => {
            resultadosMap[r.idx] = r;
          });
        }
      } catch (e) {
        // Si falla, seguimos sin lotes automáticos
      }
    }

    const nuevos = insumos.map((row, idx) => {
      const resultado = resultadosMap[idx];
      let entregar = maxPorFila[idx];
      let extra = {};
      if (resultado) {
        entregar = Number(Math.min(entregar, resultado.cantidadCubierta));
        extra = { lotes: resultado.lotes };
      }
      return { ...row, entregar, ...extra };
    });

    form.setFieldsValue({ insumos: nuevos });
    this.setState({ loading: false });
  };


  render() {
    const isMobile = window.innerWidth <= 1000;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Entregar Insumos sobre Embarque"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <h1>
              Fecha:{" "}
              {moment(this.state.datosEmbarque?.createdAt).format("LL")}
            </h1>
          }
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="entregarInsumosEmbarque"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Entregar
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <Row >
                <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                  <h1 style={{ margin: 0 }}>
                    Proyecto: {this.state.datosEmbarque?.proyecto.nombre}
                  </h1>
                  <p>
                    Descripcion:{" "}
                    {this.state.datosEmbarque?.proyecto.descripcion}
                  </p>
                </Col>
                <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                  <h1 style={{ margin: 0 }}>Dirección</h1>
                  {this.state.datosEmbarque?.proyecto.calle ? (
                    <>
                      <p style={{ margin: 0 }}>
                        Calle: {this.state.datosEmbarque?.proyecto.calle}
                      </p>
                      <p style={{ margin: 0 }}>
                        Numero:{" "}
                        {this.state.datosEmbarque?.proyecto.numeroCalle}
                      </p>
                    </>
                  ) : (
                    <>
                      <p style={{ margin: 0 }}>
                        Marca: {this.state.datosEmbarque?.proyecto.marca}
                      </p>
                      <p style={{ margin: 0 }}>
                        Modelo: {this.state.datosEmbarque?.proyecto.modelo}
                      </p>
                      <p style={{ margin: 0 }}>
                        Placas: {this.state.datosEmbarque?.proyecto.placas}
                      </p>
                    </>
                  )}
                </Col>
                <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                  <h1 style={{ margin: 0 }}>
                    Cliente:{" "}
                    {this.state.datosEmbarque?.cliente.nombre
                      ? this.state.datosEmbarque?.cliente.nombre +
                      " " +
                      this.state.datosEmbarque?.cliente
                        .apellidoPaterno +
                      " " +
                      this.state.datosEmbarque?.cliente.apellidoMaterno
                      : this.state.datosEmbarque?.cliente.razonSocial}
                  </h1>
                  <p style={{ margin: 0 }}>
                    Rfc: {this.state.datosEmbarque?.cliente.rfc}
                  </p>
                  <p style={{ margin: 0 }}>
                    Correo: {this.state.datosEmbarque?.cliente.correo}
                  </p>
                  <p style={{ margin: 0 }}>
                    Telefono:{" "}
                    {this.state.datosEmbarque?.cliente.telefono}
                  </p>
                  <p style={{ margin: 0 }}>
                    Celular: {this.state.datosEmbarque?.cliente.celular}
                  </p>
                </Col>
                <Col xs={24} sm={24} lg={isMobile ? 24 : 6} xl={isMobile ? 24 : 6}>
                  <p style={{ margin: 0 }}>
                    Contacto:{" "}
                    {this.state.datosEmbarque?.cliente.nombreContacto}
                  </p>
                  <p style={{ margin: 0 }}>
                    Tel. Contacto:{" "}
                    {this.state.datosEmbarque?.cliente.telefonoContacto}
                  </p>
                  <p style={{ margin: 0 }}>
                    Correo Contacto:{" "}
                    {this.state.datosEmbarque?.cliente.correoContacto}
                  </p>
                  <p style={{ margin: 0 }}>
                    Dias de crédito:{" "}
                    {this.state.datosEmbarque?.cliente.diasCredito}
                  </p>
                </Col>
              </Row>
              <Divider style={{ marginBottom: 10, marginTop: 5 }} />
              <Row >
                <Col span={8} ></Col>
                <Col span={8} xs={24} sm={24} md={isMobile ? 24 : 12} lg={isMobile ? 24 : 8} xl={isMobile ? 24 : 8}>
                  <FormItem
                    label="Fecha de Entrega"
                    name="fechaEntrega"
                    required
                    margin
                    initialValue={moment()}
                  >
                    <DatePickerItem
                      placeholder="Fecha de Entrega"
                      allowClear={false}
                    />
                  </FormItem>
                </Col>
                <Col span={8}></Col>
              </Row>
              <FormInitial.List name="insumos">
                {(fields) => (
                  <>
                    <div style={{ overflowX: 'auto' }}>
                      <table className="table" style={{ minWidth: isMobile ? "900px" : "100%" }}>
                        {fields.length > 0 ? (
                          <thead>
                            <tr>
                              <th className="th-border" style={{ width: "20%" }}>
                                Insumo
                              </th>
                              <th className="th-border" style={{ width: "20%" }}>
                                Proyecto
                              </th>
                              <th className="th-border" style={{ width: "10%" }}>
                                Cantidad Proyecto
                              </th>
                              {!isMobile &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Precio Unitario
                                </th>}
                              {!isMobile &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Cantidad Pedida
                                </th>}
                              {!isMobile &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Cantidad Entregada
                                </th>
                              }

                              <th className="th-border" style={{ width: "10%", textAlign: "center" }}>
                                Cantidad a entregar
                                <Tooltip title='Poner maximos.'>
                                  <CalculatorOutlined onClick={this.setMaxEntregarTodos} style={{ marginLeft: '5px', color: 'green' }} />
                                </Tooltip>
                              </th>
                              <th className="th-border" style={{ width: "10%" }}>
                                Accion
                              </th>
                            </tr>
                          </thead>
                        ) : null}
                        {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => (
                          <FormItem key={fieldKey} noStyle shouldUpdate>
                            {({ getFieldValue }) => {
                              const row = (getFieldValue('insumos') || [])[arrayKey];
                              const lotes = row?.lotes || [];
                              const insumo = this.state.todasInsumos?.find(i => i._id === row?.insumoId);
                              const necesitaLotes = insumo?.lotesCaducidades;
                              const entregar = row?.entregar || 0;
                              const sumLotes = lotes.reduce((s, l) => s + (l.cantidadRequerida || 0), 0);
                              const isRed = necesitaLotes && entregar > 0 && sumLotes !== entregar;
                              return (
                          <tbody>
                            <tr style={isRed ? { backgroundColor: '#ffccc7' } : {}}>
                              <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "insumoId"]}
                                  fieldKey={[fieldKey, "insumoId"]}
                                  required
                                  noStyle
                                >
                                  <SelectItem
                                    sinBorde
                                    style={{ width: "100%" }}
                                    placeholder="Insumo"
                                    disabled
                                  >
                                    {this.state.objetoInsumos}
                                  </SelectItem>
                                </FormItem>
                              </td>
                              <td className="td-border">
                                <FormItem
                                  shouldUpdate={(prev, curr) =>
                                    prev.proyectoId !== curr.proyectoId
                                  }
                                  noStyle
                                >
                                  {({ getFieldValue }) => {
                                    const arrayValue = getFieldValue("insumos");
                                    const insumoValue = arrayValue[arrayKey]
                                    return (
                                      <FormItem
                                        {...restField}
                                        name={[name, "proyectoId"]}
                                        fieldKey={[fieldKey, "proyectoId"]}
                                        required
                                        noStyle
                                      >
                                        <SelectItem
                                          sinBorde
                                          style={{ width: "100%" }}
                                          placeholder="Proyecto"
                                          disabled={insumoValue?.apartado > 0}
                                          onChange={(value) =>
                                            this.onChangeInsumoProyecto(
                                              value,
                                              arrayKey
                                            )
                                          }
                                        >
                                          {this.state.objetoProyectos}
                                        </SelectItem>
                                      </FormItem>
                                    );
                                  }}
                                </FormItem>
                              </td>
                              <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "cantidadProyecto"]}
                                  required
                                  noStyle
                                >
                                  <InputNumberItem
                                    sinBorde
                                    disabled
                                    placeholder="Cantidad en Proyecto"
                                  />
                                </FormItem>
                              </td>
                              {!isMobile && <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "precioUnitarioAjustado"]}
                                  fieldKey={[fieldKey, "precioUnitarioAjustado"]}
                                  noStyle
                                >
                                  <InputNumberItem
                                    sinBorde
                                    placeholder="Precio Unitario"
                                    disabled
                                    dineroDisabled
                                  />
                                </FormItem>
                              </td>}
                              {!isMobile && <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "cantidad"]}
                                  fieldKey={[fieldKey, "cantidad"]}
                                  required
                                  number
                                  noStyle
                                >
                                  <InputNumberItem
                                    sinBorde
                                    placeholder="Cantidad Pedida"
                                    disabled
                                  />
                                </FormItem>
                              </td>}
                              {!isMobile && <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "entregado"]}
                                  fieldKey={[fieldKey, "entregado"]}
                                  required
                                  numberCero
                                  noStyle
                                  initialValue={0}
                                >
                                  <InputNumberItem
                                    sinBorde
                                    placeholder="Cantidad Entregada"
                                    disabled
                                  />
                                </FormItem>
                              </td>}
                              <td className="td-border">
                                <FormItem shouldUpdate noStyle>
                                  {({ getFieldValue }) => {
                                    // arrayKey en ambas lecturas: antes el embarque se
                                    // indexaba con fieldKey y cantidadProyecto con
                                    // arrayKey. Hoy coinciden, pero son dos indices
                                    // distintos de Form.List.
                                    const filaEmbarque =
                                      this.state.datosEmbarque?.insumos?.[arrayKey];
                                    const insumos = getFieldValue("insumos");
                                    const maxDisabled = calcularMaxDisponible({
                                      cantidad: filaEmbarque?.cantidad,
                                      yaMovido: filaEmbarque?.entregado,
                                      cantidadProyecto: insumos?.[arrayKey]?.cantidadProyecto,
                                    });
                                    return (
                                      <FormItem
                                        {...restField}
                                        name={[name, "entregar"]}
                                        fieldKey={[fieldKey, "entregar"]}
                                        numberCero
                                        noStyle
                                        max={maxDisabled}
                                        type="number"
                                      >
                                        <InputNumberItem
                                          sinBorde
                                          placeholder={"Max: " + maxDisabled}
                                        />
                                      </FormItem>
                                    );
                                  }}
                                </FormItem>
                              </td>
                              <td className="td-border">
                                <Row>
                                  <Col span={24}>
                                    <FormItem
                                      noStyle
                                      shouldUpdate
                                    >
                                      {({ getFieldValue }) => {
                                        let arrayValue = getFieldValue("insumos");
                                        let mostrarMarbetes = false
                                        let mostrarLotes = false
                                        let mostrarAgrupaciones = false
                                        let insumoId
                                        let proyectoId
                                        if (arrayValue[arrayKey]?.insumoId && this.state.todasInsumos) {
                                          const insumo = this.state.todasInsumos.find(
                                            (valueInsumos) => valueInsumos._id === arrayValue[arrayKey].insumoId
                                          );
                                          mostrarMarbetes = insumo?.marbetes
                                          mostrarLotes = insumo?.lotesCaducidades
                                          mostrarAgrupaciones = insumo?.agrupaciones
                                          insumoId = insumo?._id
                                          proyectoId = arrayValue[arrayKey]?.proyectoId
                                        }
                                        if (mostrarMarbetes) {
                                          return (
                                            <ButtonItem
                                              type="primary"
                                              size='small'
                                              style={{ width: '80%', marginLeft: '10%' }}
                                              block
                                              onClick={() => {
                                                this.abrirElegirMarbetes(arrayKey, arrayValue[arrayKey].marbetes, insumoId, proyectoId)
                                              }}
                                            >
                                              Mar.
                                            </ButtonItem>
                                          )
                                        }
                                        if (mostrarAgrupaciones) {
                                          return (
                                            <ButtonItem
                                              type="primary"
                                              size='small'
                                              style={{ width: '80%', marginLeft: '10%' }}
                                              block
                                              onClick={() => {
                                                this.abrirElegirAgrupaciones(arrayKey, arrayValue[arrayKey].agrupaciones, insumoId, proyectoId)
                                              }}
                                            >
                                              Agr.
                                            </ButtonItem>
                                          )
                                        }
                                        if (mostrarLotes) {
                                          return (
                                            <ButtonItem
                                              type="primary"
                                              size='small'
                                              style={{ width: '80%', marginLeft: '10%' }}
                                              block
                                              onClick={() => {
                                                this.abrirElegirLotes(arrayKey, arrayValue[arrayKey].lotes, insumoId, proyectoId, arrayValue[arrayKey].entregar)
                                              }}
                                            >
                                              {this.props.taxidermia ? "Animales" : "Lotes"}
                                            </ButtonItem>
                                          )
                                        }
                                      }}
                                    </FormItem>
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                          </tbody>
                              );
                            }}
                          </FormItem>
                        ))}
                      </table>
                    </div>
                  </>
                )}
              </FormInitial.List>
            </Form>
          </Spin>
        </div>
        <ElegirMarbetes
          visible={this.state.modalElegirMarbetes}
          cerrarElegirMarbetes={this.cerrarElegirMarbetes.bind(this)}
          marbetes={this.state.modalElegirMarbetesMarbetes}
          insumoId={this.state.modalElegirMarbetesInsumoId}
          proyectoId={this.state.modalElegirMarbetesProyectoId}
        />
        <ElegirLotes
          visible={this.state.modalElegirLotes}
          cerrarElegirLotes={this.cerrarElegirLotes.bind(this)}
          lotes={this.state.modalElegirLotesLotes}
          insumoId={this.state.modalElegirLotesInsumoId}
          proyectoId={this.state.modalElegirLotesProyectoId}
          clienteId={this.state.modalElegirLotesClienteId}
          embarqueId={this.state.id}
          cantidad={this.state.modalElegirLotesCantidad}
          modoCantidad="exacta"
        />
        <ElegirAgrupaciones
          visible={this.state.modalElegirAgrupaciones}
          cerrarElegirAgrupaciones={this.cerrarElegirAgrupaciones.bind(this)}
          agrupaciones={this.state.modalElegirAgrupacionesAgrupaciones}
          insumoId={this.state.modalElegirAgrupacionesInsumoId}
          proyectoId={this.state.modalElegirAgrupacionesProyectoId}
          clienteId={this.state.modalElegirAgrupacionesClienteId}
          embarqueId={this.state.id}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    taxidermia: state.empresa.taxidermia,
  };
};

export default connect(mapStateToProps)(EntregarInsumosEmbarque);
